import type { ListEntitiesResponse } from "client/api/ListEntitiesResponse";
import axiosClient from "../axios-client";

export interface OctopusCloudRegionDto {
  id: string;
}

const BASE_URL = "octopus-cloud-region";

// TODO define query object
export const getOctopusCloudRegions = async (
  query?: Record<string, string | number>
): Promise<ListEntitiesResponse<OctopusCloudRegionDto>> => {
  const response = await axiosClient.get<ListEntitiesResponse<OctopusCloudRegionDto>>(BASE_URL, {
    params: query,
  });
  return response.data;
};
